<template>
  <div>
    <ahc-filter
      class="filter--no-grid"
      v-if="hasFilter"
      :filterData="filterData"
      :showReset="showFilterReset"
      @filterUpdate="handleFilter"
      @filterReset="handleReset"
      @filterReady="handleReady"
    ></ahc-filter>

    <slot
      v-if="isReady"
      :ajaxItems="ajaxItems"
      :isFetching="isFetching"
      :loadMore="loadMore"
      :hasMore="hasMore"
      :showingFirstResults="showingFirstResults"
    ></slot>
  </div>
</template>

<script lang="js">
import axios from 'axios';
import ahcFilter from "../filter/filter.vue";

export default  {
  name: 'ahc-post-list',
  components: {
    ahcFilter
  },
  props: {
    itemsPerNewPage: {
      type: Number,
      default: 4
    },
    columnCount: {
      type: Number,
      default: 4
    },
    endpoint: {
      type: String,
      required: true
    },
    filterData: {
      type: Object,
      default: null,
    },
    showFilterReset: {
      type: Boolean,
      default: true,
    },
    totalPosts: {
      type: Number,
    }
  },
  data() {
    return {
      ajaxItems: [],
      isFetching: false,
      hasMore: true,
      hasFilter: false,
      initialCount: 0,
      showingFirstResults: true,
      filterValue: null,
      ready: false,
      isContentList: false,
      currentTotal: this.totalPosts,
    }
  },
  computed: {
    isReady() {
      return (!this.hasFilter || (this.hasFilter && this.ready));
    }
  },
  mounted() {
    this.isContentList = this.$el.classList.contains('content-list');
    this.hasFilter = this.filterData && Object.keys(this.filterData).length !== 0;
    this.initialCount = this.$el.querySelectorAll('.block-list__item').length;
  },
  methods: {
    getFilteredResults(topic) {
      this.isFetching = true;
      this.filterValue = topic;
      this.initialCount = 0;
      let config = { params: { offset: 0, limit: this.itemsPerNewPage } };
      if(topic) {
        config.params.topics = topic;
      }

      axios
          .get(this.endpoint, config)
          .then(response => {
            this.isFetching = false;
            this.showingFirstResults = false;

            if(response.data['total_posts']) {
              this.currentTotal = response.data['total_posts'];
            }
            this.hasMore = (this.getCurrentCount() + Object.keys(response.data.items).length) < this.currentTotal;
            this.ajaxItems = response.data.items;
          })
          .catch(err => {
            console.error(err);
            this.isFetching = false;
          });
    },
    loadMore() {
      if (!this.isFetching) {
        this.isFetching = true;
        const nextIndex = (this.showingFirstResults) ? this.initialCount + this.ajaxItems.length : this.ajaxItems.length;
        const limit = this.itemsPerNewPage;
        let config = { params: { offset: nextIndex, limit: limit } }
        if(this.hasFilter) {
          config.params.topics = this.filterValue;
        }

        axios
          .get(this.endpoint, config)
          .then(response => {
            this.isFetching = false;

            if(response.data['total_posts']) {
              this.currentTotal = response.data['total_posts'];
            }

            // if the total of what's currently displayed plus the new results is less than
            // the total posts of this query, show the "load more" button
            this.hasMore = (this.getCurrentCount() + Object.keys(response.data.items).length) < this.currentTotal;

            if (response.data.items && response.data.items.length) {
              this.ajaxItems = this.ajaxItems.concat(response.data.items);

              // on next tick, focus on the first newly loaded item
              // but save and restore the scroll position to prevent a "jump" on focus
              const savedScrollPosition = window.pageYOffset;

              this.$nextTick(() => {
                const listItems = this.$el.querySelectorAll('.block-list__item');

                if (listItems[nextIndex]) {
                  listItems[nextIndex].focus();

                  requestAnimationFrame(() => {
                    window.scrollTo(0, savedScrollPosition);
                  });
                }
              });
            }
          })
          .catch(err => {
            console.error(err);
            this.isFetching = false;
          });
      }
    },
    handleFilter(filterSelections) {
      this.getFilteredResults(filterSelections['Topics']);
    },
    handleReset() {
      this.getFilteredResults(null);
    },
    handleReady() {
      this.ready = true;
    },
    getCurrentCount() {
      return this.initialCount + this.ajaxItems.length;
    }
  }
}
</script>
